import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-569b3f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-6",
  class: "page-6"
}
const _hoisted_2 = { class: "d-none d-md-block box-tab" }

import ResponsiveImage from '../responsive-image.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpg'),
      "image-webp": require('./bg.webp'),
      "mobile-image": require('./bg-m.jpg'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 3816,
      "image-w": 3840,
      "mobile-image-h": 7086,
      "mobile-image-w": 1170
    }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppTabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_AppTab, { label: "하나, 투명 음료 페트병만!" }, {
            default: _withCtx(() => [
              _createVNode(ResponsiveImage, {
                class: "tab-1-content",
                image: require('./tab-1.png'),
                "image-webp": require('./tab-1.webp')
              }, null, 8, ["image", "image-webp"])
            ]),
            _: 1
          }),
          _createVNode(_component_AppTab, { label: "둘, 분리배출 표시" }, {
            default: _withCtx(() => [
              _createVNode(ResponsiveImage, {
                class: "tab-2-content",
                image: require('./tab-2.png'),
                "image-webp": require('./tab-2.webp')
              }, null, 8, ["image", "image-webp"])
            ]),
            _: 1
          }),
          _createVNode(_component_AppTab, { label: "셋, 음료 페트병" }, {
            default: _withCtx(() => [
              _createVNode(ResponsiveImage, {
                class: "tab-3-content",
                image: require('./tab-3.png'),
                "image-webp": require('./tab-3.webp')
              }, null, 8, ["image", "image-webp"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})